/* eslint-disable @next/next/no-img-element */
import Link from "next/link";
import React, { FC } from "react";
import st from "./index.module.scss";

interface CollectionItemProps {
  image: string;
  title: string;
  nutritionLink: string;
  price?: string;
  slug: string;
  flavorName: string;
  focus?: boolean;
}

const CollectionItem: FC<CollectionItemProps> = ({
  image,
  title,
  nutritionLink,
  slug,
  price = "",
  flavorName,
  focus,
}) => {
  return (
    <li className={st.rockstarProductItem}>
      <div className={st.productItem}>
        <Link
          href={`/products/${slug}/`}
          title={title}
          className={st.productImg}
        >
          <img src={image} alt={title} />
        </Link>
        <div>
          <Link
            href={`/products/${slug}/`}
            title="Product"
            className={st.productItemDetail}
          >
            <h2>{title}</h2>
          </Link>
          <span className={st.productFlavorName}>{flavorName}</span>
          <div className={st.itemBottomDetails} data-gtin="00818094000123">
            <a
              href={nutritionLink}
              className={st.productNutrition}
              target="_blank"
              title=""
              rel="noreferrer"
            >
              Nutrition
            </a>
            <span className={st.productPrice}>{price}</span>
          </div>
        </div>
      </div>
    </li>
  );
};

export default CollectionItem;
